import { createModal, StaticModal } from '@nexelem/modals';
import { BillOfMaterialTable } from './BillOfMaterialTable';

type BillOfMaterialModalProps = {
  taskId: string;
};

const BillOfMaterialModal = ({ taskId }: BillOfMaterialModalProps) => (
  <StaticModal fullScreen onClose={closeBillOfMaterialModal}>
    <StaticModal.Content className="flex flex-col gap-6 p-0">
      <BillOfMaterialTable taskId={taskId} />
    </StaticModal.Content>
  </StaticModal>
);

export const { openBillOfMaterialModal, closeBillOfMaterialModal } = createModal(BillOfMaterialModal, {
  name: 'BillOfMaterialModal',
});
